import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../Logo';
import '../../styles/sidebar.scss';
import Close from '../../icons/close.svg';

const Sidebar = ({
  forwardRef, children, toggleShow, active,
}) => (
  <div ref={forwardRef} className={`sidebar ${active ? '' : 'hidden'}`}>
    <div className="top">
      <Logo />
      <button className="go-back-arr" onClick={() => { toggleShow(false); }} type="button">
        <Close className="close-button" />
      </button>
    </div>
    <div className="sidebar-wrapper">
      <div className="content">{children}</div>
    </div>
  </div>
);
Sidebar.propTypes = {
  toggleShow: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  forwardRef: PropTypes.instanceOf(Object).isRequired,
  active: PropTypes.bool.isRequired,

};
export default Sidebar;
